import { handleAPI, API_VERSION_ONE } from '../../../../itrust_common/utils/apiUtils';


export function itrustPayOnboarding(data) {
  const url = `/${API_VERSION_ONE}/add_ons/itrust_pay/onboarding`;
  const method = 'POST'
  return {
    type: `ITRUST_PAY_ONBOARDING`,
    payload: handleAPI(url, {}, method, data)
  };
}

export function itrustPaySettingsLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_on`;
  const method = 'GET';
  return {
    type: 'ITRUST_PAY_SETTINGS_LOAD',
    payload: handleAPI(url, filters, method)
  };
}

export function itrustPayOnboardingUpdate(data) {
  const url = `/${API_VERSION_ONE}/add_ons/itrust_pay/onboarding/${data.id}`;
  const method = 'PATCH'
  return {
    type: `ITRUST_PAY_ONBOARDING_UPDATE`,
    payload: handleAPI(url, {}, method, data)
  };
}

export function itrustPayPayoutsLoad(filters) {
  const url = `/${API_VERSION_ONE}/add_ons/itrust_pay/payout_logs`;
  const method = 'GET'

  return {
    type: `ITRUST_PAY_PAYOUTS_LOAD`,
    payload: handleAPI(url,filters, method)
  };
}

export function itrustPayWalletLoad(data) {
  const url = `/${API_VERSION_ONE}/add_ons/itrust_pay/payout_logs/wallet_details`;
  const method = 'GET'

  return {
    type: `ITRUST_PAY_WALLET_LOAD`,
    payload: handleAPI(url, {}, method, data)
  };
}
